import apiRequest, {
  getErrorCode,
  getErrorDescription,
} from "utils/apiRequestWithErrorCode";
import type {
  AuthenticatedUserResponse,
  CreateUserBody,
  UpdateUserBody,
  UserResource,
  UserResourceList,
} from "@dashboard-v3/api";

export async function fetchUserList() {
  return apiRequest<UserResourceList>("GET", "/users");
}

export async function deleteUser(userId: string) {
  return apiRequest("DELETE", `/users/${userId}`);
}

export async function updateUser(id: string, changes: UpdateUserBody) {
  return apiRequest<AuthenticatedUserResponse>(
    "PATCH",
    `/users/${id}`,
    changes
  );
}

export async function createUser(userData: CreateUserBody) {
  return apiRequest<UserResource>("POST", "/users", userData);
}

export function handleError(
  action: "deleteUser" | "patchUser" | "postUser",
  error: unknown,
  onError: (errorKeys: string[]) => void
) {
  const code = getErrorCode(error);
  const message = getErrorDescription(error);
  if (code === "INVALID_PASSWORD") {
    throw error;
  }
  const errorMessages = [
    `error.${action}.${code}`,
    `error.${action}.${message}`,
    `error.${action}.SYSTEM_FAILURE`,
  ];
  console.error(error);
  onError(errorMessages);
}
